import { atom } from 'recoil';

export const CanDirectToHereState = atom({
    key: 'CanDirectToHereState', 
    default: true, 
});